type PatientSummarySource = {
  patientName?: unknown;
  patientAge?: unknown;
  patientSex?: unknown;
};

export const normalizeScheduleText = (value?: unknown): string | null => {
  if (value == null) return null;
  const normalized = String(value).trim();
  return normalized || null;
};

// Manually scheduled cases have a physician ID but no denormalized name.
// Match Procedure.physicianName's existing "Dr <last name>" presentation.
export const schedulePhysicianName = (procedure: {
  physicianName?: unknown;
  physician?: { name?: unknown } | null;
}): string | null => {
  const storedName = normalizeScheduleText(procedure.physicianName);
  if (storedName) return storedName;
  const linkedName = normalizeScheduleText(procedure.physician?.name);
  return linkedName ? `Dr ${linkedName.split(/\s+/).pop()}` : null;
};

export const formatScheduleTime = (value?: unknown): string => {
  const normalized = normalizeScheduleText(value);
  return normalized == null || normalized === '-' ? '–' : normalized;
};

export const formatPatientSummary = ({ patientName, patientAge, patientSex }: PatientSummarySource): string =>
  [normalizeScheduleText(patientName) ?? '–', normalizeScheduleText(patientAge), normalizeScheduleText(patientSex)]
    .filter(Boolean)
    .join(' ');
